import { handleSignup } from "@/server/controllers/authController";
import { SignupForm } from "@/app/components/auth/SignupForm";
import { ROUTES } from "@/app/utils/constants";
import { handleFormAction } from "@/app/utils/remix-helpers.server";
import { createSignupValidator } from "@/app/utils/validators";
import { queueEvent } from "@/app/marketing/tracking.server";
import { createAuthSessionCookie } from "@/app/utils/session.server";
import { redirect } from "@remix-run/server-runtime";

export const action = handleFormAction(
  { form: createSignupValidator() },
  async ({ formData, request }) => {
    const session = await handleSignup(request, formData);

    // Queue signup event
    const trackingCookie = await queueEvent(request, {
      eventType: "signup",
    });

    // Append each cookie as its own Set-Cookie header. Comma-joining them into
    // one header breaks now that the session cookie's Expires date itself
    // contains a comma.
    const headers = new Headers();
    headers.append(
      "Set-Cookie",
      await createAuthSessionCookie(request, session)
    );
    headers.append("Set-Cookie", trackingCookie);

    return redirect(ROUTES.ORG_NEW, { headers });
  }
);

export default function SignupPage() {
  return <SignupForm />;
}
